import { AdjustmentNoteCategoryEnum } from "@gtpl/shared-models/common-models";

export class AdjutsmentNoteCategoryReq{
    category:AdjustmentNoteCategoryEnum
    noteNumber:string
    invoiceNumber:string
    vendorId?:number

    constructor(category:AdjustmentNoteCategoryEnum,noteNumber:string,invoiceNumber:string,vendorId?:number){
        this.category = category
        this.noteNumber = noteNumber
        this.invoiceNumber = invoiceNumber
        this.vendorId = vendorId
    }
}